<template>
  <sidebar-content submitLabel="Enviar" hideSubmit :open="openModal" @close="closeModal">
    <!-- <v-stepper v-if="list_events.length > 0" class="elevation-0" v-model="step" vertical v-resize="onResize" :style="setHeightScroll"> -->
    <v-stepper class="elevation-0" vertical v-model="step" v-resize="onResize" :style="setHeightScroll">
      <v-stepper-step step="1" :complete="step > 1" class="px-0">
        <h2 class="title">Canais de Comunicação</h2>
      </v-stepper-step>
      <v-stepper-content step="1" class="px-0">
        <v-container justify-start grid-list-lg class="mx-0 py-0" style="width: calc(100% - 40px)">
          <!-- <p>Escolha e configure os Canais que deseja utilizar</p> -->
          <v-form v-model="validStep1" ref="formStep1" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <v-switch
                  class=""
                  disabled
                  v-model="showModal"
                  label="Dados inteligentes"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  item-value="id"
                  item-text="name"
                  v-model="newData.costCenter"
                  required :rules="validate.requiredRules"
                  :items="itemsCost"
                  label="Centro de Custo"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12>
                <p class="darkGray--text">Notificações:</p>
                <v-radio-group v-model="typeRecipient" row required :rules="validate.requiredRules">
                  <v-radio label="Auto de Constatação" value="auto_constatacao"></v-radio>
                  <v-radio label="Auto de Infração" value="auto_infracao"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm4>
                <card-checked
                  title="Carta"
                  color="secondary"
                  displayMode
                  icon="email"
                  :checked="letterChecked"
                  @change="changeLetter"
                >
                  <v-radio-group
                    :rules="validate.requiredRules"
                    required
                    @change="changeLetterOptions"
                    v-model="radioGroup"
                  >
                    <v-radio
                      color="secondary"
                      v-for="(option, index) in letterOptions"
                      :key="`${option}-${index}`"
                      :label="option.label"
                      :value="option" >
                    </v-radio>

                  </v-radio-group>

                </card-checked>
              </v-flex>
              <v-flex xs12 sm4>
                <card-checked
                  title="SMS"
                  displayMode
                  color="accent"
                  icon="textsms"
                  :checked="smsChecked"
                >
                  <!-- <v-layout justify-center align-center>Em breve</v-layout> -->

                </card-checked>
              </v-flex>
              <v-flex xs12 sm4>
                <card-checked
                  title="E-mail"
                  displayMode
                  color="accent"
                  icon="mdi-at"
                  :checked="emailChecked"
                >
                </card-checked>
              </v-flex>
            </v-layout>

            <div class="actions-step-fixed">
              <v-btn
                @click="submitStep1"
                :disabled="!validStep1"
                depressed
                :loading="isLoading"
                color="accent"
                >
                Avançar
              </v-btn>
            </div>

          </v-form>
        </v-container>

      </v-stepper-content>

      <v-stepper-step step="2" :complete="step > 2" class="px-0">
        <h2 class="title">Dados Pessoais</h2>
      </v-stepper-step>
      <v-stepper-content step="2" class="px-0">
        <v-container grid-list-lg class="pa-0">
          <v-form v-model="validStep2" ref="formStep2">

            <form-user
              ref="formUser"
              hasInvestigator
              hideSubmit
              :items="recipient"
              emailActions
              @validate="formUserValidate"
              @blur="updateDataPersonal"
              @investigator="setInvestigator"
              @empty="emptyDataUser"
              class="negative-margin-lg"
              >
            </form-user>
            <div class="actions-step-fixed">
              <v-btn
                title="Voltar ao passo anterior"
                depressed
                flat
                class="textColor--text"
                @click.native="prevStep">
                voltar
              </v-btn>
              <v-btn
                depressed
                @click="submitStep2"
                :disabled="!validStep2"
                color="accent"
                title="Ir para o próximo passo"
                >
                Avançar
              </v-btn>
            </div>
          </v-form>
        </v-container>

      </v-stepper-content>

      <v-stepper-step step="3" :complete="step > 3" class="px-0">
        <h2 class="title">Dados de Endereço</h2>
      </v-stepper-step>
      <v-stepper-content step="3" class="px-0">
        <v-form v-model="validStep3" ref="formStep3" lazy-validation>

            <form-address
              ref="formAddress"
              :items="addresses"
              :empty="emptyDataAddress"
              hideSubmit
              :investigator="investigator.addresses"
              @blur="updateDataAddress"
              @validate="formAddressValidate"
              class="negative-margin-lg"
              >
            </form-address>

            <div class="actions-step-fixed">
              <v-btn
                title="Voltar ao passo anterior"
                depressed
                flat
                class="textColor--text"
                @click.native="prevStep">
                voltar
              </v-btn>
              <v-btn
                @click="submitStep3"
                title="Criar um caso"
                :disabled="!validStep3"
                depressed
                color="accent"
                >
                Criar
              </v-btn>
            </div>
          </v-form>

      </v-stepper-content>
    </v-stepper>
    <!-- <empty-state v-else size="75px" :icon="$root.icons.link.events" class="absolute-center">
      <h1 class="main-title"></h1>
      <h1 class="main-title">Crie um evento</h1>
      <p class="subheading">Um <b>Evento</b> é criação de regras que serão aplicadas nos casos inseridos e registrados na plataforma <br>Crie um <b>Evento</b> em apenas 4 passos</p>
      <v-btn color="accent" small depressed fab @click="createEvent">
        <v-icon>{{$root.icons.action.add}}</v-icon>
      </v-btn>
    </empty-state> -->
  </sidebar-content>
</template>

<script>
  import SidebarContent from '@/components/ui/SidebarContent'
  import FormUser from '@/components/ui/forms/FormUser'
  import FormAddress from '@/components/ui/forms/FormAddress'
  import CardChecked from '@/components/ui/CardChecked'
  import Loading from '@/components/ui/Loading'
  import resizing from '@/utils/resizing'

  export default {
    name: 'RecipientNew',
    mixins: [ resizing ],
    components: {
      SidebarContent,
      FormAddress,
      FormUser,
      CardChecked,
      Loading
    },
    data: () => ({
      showModal: false,
      typeRecipient: null,
      radioGroup: null,
      letterChecked: true,
      emailChecked: false,
      smsChecked: false,
      openModal: false,
      showModalConfirm: false,
      isEditCase: false,
      itemsCost: [
        {
          id: 'arrecadacao',
          name: 'Arrecadação'
        },
        {
          id: 'divida_ativa',
          name: 'Dívida Ativa'
        },
        {
          id: 'fiscalizacao',
          name: 'Fiscalização'
        }
      ],
      letterOptions: [
        {
          label: 'Simples',
          value: 'simple'
        },
        {
          label: 'Registrados',
          value: 'registered'
        },
        {
          label: 'AR',
          value: 'simple_ar'
        },
        {
          label: 'AR mãos próprias',
          value: 'hand_ar'
        }
      ],
      step: 1,
      validStep1: true,
      validStep2: true,
      validStep3: true,
      showAddress: false,
      showPhone: false,
      recipient: {
        type: 'pf',
        document: '',
        dateBirth: '',
        email: '',
        name: '',
        phones: []
      },
      addresses: {
        type: '',
        address: '',
        complement: '',
        number: '',
        neighborhood: '',
        city: '',
        uf: '',
        zipCode: ''
      },
      newData: {
        costCenter: '',
        recipient: {
          type: '',
          document: '',
          dateBirth: '',
          email: '',
          name: '',
          phones: [],
          address: []
        }
      },
      investigator: {},
      emptyDataAddress: null,
      loading: 0,
    }),
    methods: {
      changeLetter (isChecked) {
        // this.letterChecked = isChecked
      },
      changeLetterOptions (options) {
        console.log('options', options)
      },
      openSidebar () {
        this.openModal = true
        this.isEditCase = false
      },
      closeModal () {
        this.openModal = false
        this.$nextTick(() => {
          this.$router.push({ name: 'RecipientIndex' })
        })
      },
      updateDataPersonal (data) {
        // this.showAddress = true
        this.newData.recipient = data
      },
      setInvestigator (investigator) {
        // this.showAddress = true
        console.log('setInvestigator', investigator)
        this.$nextTick(() => { this.investigator = investigator })
      },
      updateDataAddress (address) {
        let recipient = this.recipient
        this.newData = Object.assign(this.newData, { recipient: {address} })
      },
      submitStep2 () {
        this.validStep1 = this.$refs.formUser.validation()
        if (this.$refs.formUser.validation()) {
          console.log('step 2', this.newData)
          this.step = 3
        }
      },
      submitStep3 () {
        this.validStep3 = this.$refs.formAddress.validation()
        if (this.$refs.formAddress.validation()) {
          console.log('step 3', this.newData)
          this.step = 4
          setTimeout(() => {
            this._success ()
          }, 200)
        }
      },
      submitStep1 () {
        if (this.$refs.formStep1.validate()) {
          this.step = 2
          console.log('step 1', this.newData)
          console.log('step 1 - radioGroup', this.radioGroup)
        }
      },
      prevStep () {
        this.step = this.step - 1
      },
      removeTicket (ticket) {
        // this.newData.tickets = this.newData.tickets.filter(record => record !== ticket)
      },
      addTicket () {
        // let date = new Date()
        // this.newData.tickets.push({dueAt: '', originalValue: '', description: '', id: '', timestamp: date.getTime()})
      },
      _success () {
        // this.$store.commit('global/SET_LOADING', false)
        this.$root.$emit('snackbar', {show: true, color: 'success', text: 'Destinatário criado com sucesso'})
        this.$router.push({ name: 'RecipientIndex' })
      },
      _failure () {
        // this.$store.commit('global/SET_LOADING', false)
        this.$root.$emit('snackbar', {show: true, time: 10000, color: 'error', text: 'houve um problema'})
      },
      showAddTicket (index) {
        return this.newData.tickets.length === index + 1
      },
      saveOcurrenceDate (date) {
        var setDate = {occurrenceDate: date}
        this.newData.general = Object.assign(this.newData.general, setDate)
      },
      // saveTicketsDate (date, index) {
      //   this.newData.tickets[index].dueAt = date
      // },
      // selectedEvent (eventId) {
      //   this.newData.eventId = eventId
      // },
      emptyDataUser (result) {
        this.emptyDataAddress = result
      },
      // createEvent () {
      //   this.$nextTick(this.$router.push({name: 'EventNew', query: { returnTo: 'CaseNew' }}))
      // },
      formUserValidate (isValid) {
        this.validStep1 = isValid
      },
      formAddressValidate (isValid) {
        this.validStep2 = isValid
      }
    },
    watch: {
      eventChannels (channels) {
        // let hasData = Object.keys(channels)
        // if (hasData.length > 0) {
        //   this.showPhone = channels.sms.send
        //   this.showAddress = channels.letter.send
        // }
      }
    },
    computed: {
      isLoading () {
        return this.$store.state.isLoading
      }
    },
    mounted () {
      this.openSidebar()
    },
    beforeMount () {
      this.addTicket()
    }
  }
</script>
